module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-window', {
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, _vm._l((_vm.steps), function(step) {
    return _c('v-window-item', {
      key: step.id
    }, [_vm._t(("step-" + (step.id)))], 2)
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b4bc446","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/MobileStepLayout.vue
// module id = 1323
// module chunks = 9